/**
 * Service layer — Working Notes.
 *
 * Owns the working_notes table (Supabase) behind the Clerk-authed /api/working-notes endpoint.
 * A stack of free-form, dated notes on a Thread or Milestone — extra team context, not tasks
 * and not the entity's own Activity Log. See database/199_working_notes.sql.
 */

/** Mirrors services/studioCalendar.js's token() — waits briefly for window.__clerkGetToken. */
async function token() {
  for (let i = 0; i < 25; i++) {
    if (typeof window !== 'undefined' && typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* retry */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}

async function post(payload) {
  const headers = { 'Content-Type': 'application/json' }
  const t = await token(); if (t) headers['Authorization'] = 'Bearer ' + t
  const res = await fetch('/api/working-notes', { method: 'POST', headers, body: JSON.stringify(payload) })
  const data = await res.json().catch(() => ({ error: 'Bad response from /api/working-notes' }))
  if (!res.ok || data.error) throw new Error(data.error || ('Request failed (' + res.status + ')'))
  return data
}

/** Notes for one entity, newest first. Each: { id, note, createdByMemberId, createdAt, updatedAt }. */
export async function getWorkingNotes(entityType, entityId) {
  return (await post({ action: 'list', entityType, entityId })).notes || []
}

export async function createWorkingNote(entityType, entityId, note, memberId) {
  return (await post({ action: 'create', entityType, entityId, note, memberId })).note
}

export async function updateWorkingNote(id, note) {
  return (await post({ action: 'update', id, note })).note
}

export async function deleteWorkingNote(id) {
  return (await post({ action: 'delete', id })).ok
}
